export default __webpack_public_path__ + "static/media/arrow-left-thin.a24460b5.svg";